module.exports = __webpack_public_path__ + "static/media/Avantra-vector.c54b627d.svg";